export default __webpack_public_path__ + "static/media/delivery-icon.008f49c2.svg";